import styled from "styled-components";

export const PaymentVerifyWidgetStyled = styled.div`
  position: relative;
  .payment_header_layout {
    margin-bottom: 22px;
    .payment_title {
      margin-bottom: 12px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
    .account_detail {
      margin-bottom: 23px;
      display: flex;
      column-gap: 40px;
      .row_left {
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
      }
      .row_right {
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
        .desc {
          white-space: pre-line;
        }
      }
    }
    .qr_block {
      margin-bottom: 25px;
      .qrcode_img {
        width: 100%;
        height: auto;
      }
    }
    .btn_download {
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 8px;
      cursor: pointer;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
    }
  }
  .history_wrap {
    margin-bottom: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .history_title {
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    }
    .history_seemore {
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .pay_err_wrap {
    margin-bottom: 25px;
    border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
    padding: 10px;
    display: flex;
    align-items: center;
    column-gap: 9px;
    .err_desc {
      .err_title {
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
      }
    }
  }
  .btn_back_wrap {
    margin: auto;
    max-width: 167px;
  }
  .success_wrap {
    border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
    padding: 10px;
    display: flex;
    column-gap: 9px;
    .success_desc {
      .date {
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S18};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
      }
      .success_title {
        margin: -5px 0 8px 0;
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
      }
      .success_desc {
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S10};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
        white-space: nowrap;
      }
    }
    .amount {
      padding: 13px 0;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S22};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      white-space: nowrap;
      span {
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S18};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
      }
    }
  }
  .sec {
    margin-bottom: 16px;
    &.mb_18 {
      margin-bottom: 18px;
    }
  }
`;
